ShiftsService.$inject = ['$resource', 'StoresService', '$q', 'DateService'];

function ShiftsService($resource, StoresService, $q, DateService) {
    const baseUrl = 'api/shifts';
    const Shifts = $resource(baseUrl + '/:storeId/:week/:driver', null, {
        copyWeek: {
            method: 'POST',
            url: baseUrl + '/copy'
        },
        download: {
            method: 'GET',
            url: baseUrl + '/download/:storeId/:week',
            isArray: true
        },
        allocatedOnly: {
            method: 'GET',
            url: baseUrl + '/allocatedOnly/:storeId/:week/:driver',
            isArray: true
        },
        deleteOther: {
            method: 'DELETE',
            url: baseUrl + '/other/:id'
        }
    });

    this.getShifts = getShifts;
    this.postShift = postShift;
    this.clearShift = clearShift;
    this.copyWeek = copyWeek;
    this.downloadShifts = downloadShifts;
    this.getAllocatedForDriver = getAllocatedForDriver;
    this.deleteOtherShift = deleteOtherShift;

    function getShifts(weekStartDate, driver, pageNumber) {
        const week = new Date(weekStartDate);

        return StoresService.getStore().then(store => {
            return Shifts.query({
                storeId: store.storeId,
                driver,
                week: week.toISOString().slice(0, 10),
                pageIndex: pageNumber
            }).$promise;
        });
    }

    function downloadShifts(weekStartDate) {
        const week = new Date(weekStartDate);

        return StoresService.getStore().then(store => {
            return Shifts.download({
                storeId: store.storeId,
                week: week.toISOString().slice(0, 10)
            }).$promise;
        });
    }

    function postShift(shift, driverHoliday) {
        const error = {};
        error.data = {};
        error.data.violations = [];

        if (driverHoliday) {
            error.data.violations.push('You cannot use a shift on a driver\'s holiday.');
            return $q.reject(error);
        }

        if (new Date(shift.date) < new Date().setHours(0,0,0,0)) {
            error.data.violations.push('You cannot allocate a driver to a shift in the past.');
            return $q.reject(error);
        }

        if (shift.violations && shift.violations.length > 0) {
            error.data = shift;
            return $q.reject(error);
        } else {
            if (DateService.isDate(shift.date)) {
                shift.date.setHours(12);  //chrome 46 hack
                shift.date = shift.date.toISOString().slice(0, 10);
            }
            return Shifts.save(shift).$promise;
        }
    }

    function clearShift(shift) {
        if (new Date(shift.date) < new Date().setHours(0,0,0,0)) {
            return $q.reject('You cannot change a shift in the past.');
        }
        shift.driver = null;
        return Shifts.save(shift).$promise;
    }

    function copyWeek(sourceDate, targetDate) {
        return StoresService.getStore().then(store => {
            return Shifts.copyWeek({
                storeId: store.storeId,
                sourceDate: sourceDate.toISOString().slice(0, 10),
                targetDate: targetDate.toISOString().slice(0, 10)
            }).$promise;
        });
    }

    function getAllocatedForDriver(weekStartDate, driverId) {
        return StoresService.getStore().then(store => {
            return Shifts.allocatedOnly({
                storeId: store.storeId,
                week: weekStartDate.toISOString().slice(0, 10),
                driver: driverId
            }).$promise;
        });
    }

    function deleteOtherShift(shift) {
        if (shift.type != 'Other') {
            return $q.reject('You cannot delete this type of shift.');
        }
        
        if (new Date(shift.date) < new Date().setHours(0,0,0,0)) {
            return $q.reject('You cannot change a shift in the past.');
        }
        
        return Shifts.deleteOther({ id: shift.id }).$promise;
    }
}

export default ShiftsService;



// WEBPACK FOOTER //
// ./src/js/services/shifts/index.js